import { render, staticRenderFns } from "./printing_Materials.vue?vue&type=template&id=5dca3c72&scoped=true"
import script from "./printing_Materials.vue?vue&type=script&lang=js"
export * from "./printing_Materials.vue?vue&type=script&lang=js"
import style0 from "./printing_Materials.vue?vue&type=style&index=0&id=5dca3c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dca3c72",
  null
  
)

export default component.exports